import _ from 'lodash';
import { createSelector } from 'reselect';
import {
  getBasicRecords,
  getGrowthRecords,
  getMilestoneRecords,
  getDietDiaperRecords,
  getSleepRecords
} from './core.js';
import { getSelectedBabyId } from './ui.js';
import { getProfilesById } from './profiles.js';

/**
 * Higher-order selector creator to condense the logic.
 * Handles filtering by babyId and mapping provider names.
 */
const createEnhancedRecordSelector = (baseRecordsSelector) => 
  createSelector(
    baseRecordsSelector,
    getSelectedBabyId,
    getProfilesById,
    (records, babyId, profiles) =>
      _.chain(records)
        .pickBy(r => r.babyId === babyId)
        .mapValues(r => {
          const provider = profiles[r.providerId];
          const providerName = provider 
            ? `${provider.firstName} ${provider.lastName}` 
            : r.otherProvider;

          return {
            ...r,
            provider: providerName,
            providerId: r.otherProvider ? 'other' : r.providerId
          };
        })
        .value()
  );

const getEnhancedBasicRecords = createEnhancedRecordSelector(getBasicRecords);
const getEnhancedGrowthRecords = createEnhancedRecordSelector(getGrowthRecords);
const getEnhancedDietDiaperRecords = createEnhancedRecordSelector(getDietDiaperRecords);
const getEnhancedMilestoneRecords = createEnhancedRecordSelector(getMilestoneRecords);
const getEnhancedSleepRecords = createEnhancedRecordSelector(getSleepRecords);

export {
  getEnhancedGrowthRecords,
  getEnhancedDietDiaperRecords,
  getEnhancedMilestoneRecords,
  getEnhancedBasicRecords,
  getEnhancedSleepRecords
};
